import React from 'react';
import { styled } from '@mui/material/styles';

/*
 * 아직 다듬는 중인 화면임을 알리는 표식.
 *
 * 운영에 먼저 올려 두고 쓰면서 고치려는 기능에 붙인다 — 없으면 "왜 숫자가 바뀌었냐"는
 * 문의가 버그 신고로 온다. 자리를 거의 안 먹게 작게 두고, 탭 이름 옆에 붙인다.
 */
const Badge = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  marginLeft: '5px',
  padding: '1px 5px',
  borderRadius: '5px',
  fontSize: '9.5px',
  fontWeight: 800,
  letterSpacing: '0.04em',
  lineHeight: 1.4,
  // 바디스위치 민트. 주황은 지각 배지와 겹쳐 경고처럼 읽혔다.
  color: '#0F7F85',
  background: 'rgba(74, 179, 188, 0.16)',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
});

const BetaBadge = ({ title = '준비 중인 기능이에요. 쓰면서 다듬고 있습니다.' }) => (
  <Badge title={title} aria-label="베타">BETA</Badge>
);

export default BetaBadge;
